export function disAllowedBlocks() {
	return [
		'buntywp/toggle-content',
		'buntywp/left-toggle-content',
		'buntywp/right-toggle-content',
	];
}
